// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_main {
  width: 100%;
  height: fit-content;
}

/* Balance Cards css */

.balance_cards {
  width: 100%;
}

.polygon_card {
  width: 100%;
  border: 1px solid #ffffff;
  box-shadow: -6px 10px 40px 0px #00000014;
  border-radius: 14px;
  padding: 24px;
  background-color: #ffffff90;

  display: flex;
  flex-direction: column;
  gap: 16px;
  height: fit-content;
}
.polygon_card22 {
  background-color: #ffffff;
}

/* .balance_cards{
  background-image: url('../../assets/networkSecBackground.png');
  background-repeat: no-repeat;
  background-size: cover;
} */

.imgbox {
  background-color: #1d70d2;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bnbimgbox {
  background-color: #f0b90b;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.imgbox img {
  width: 24px;
  height: 24px;
}

.card_header > span {
  font-size: 24px;
  font-weight: 600;
}

.pynWltAdr {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  flex-wrap: wrap;
}

.minimizeOpacity {
  opacity: 0.5;
}

.pynWltAdr > span:first-child {
  color: #000000;
  font-size: 15px;
  font-weight: 500;
}

#my-tooltip-1,
#my-tooltip-2 {
  padding: 3px 5px;
}

.pynWltAdr > span:last-child {
  color: #000000;
  font-size: 14px;
  font-weight: 600;
  word-break: break-all;
}

.copyaddicon {
  cursor: pointer;
}

.maticBalance {
  width: 100%;
  background: #1d70d21a;
  border-radius: 8px;
  padding: 9px 10px;
  color: #000000;
  font-size: 16px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.nbnbgColor {
  background: #f0b90b1a;
}

.maticBalance > span:first-child {
  font-weight: 500;
  margin-right: 10px;
  font-size: 15px;
}
.maticBalance > span:last-child {
  font-weight: 600;
  font-size: 15px;
}

/* Transaction Table CSS */
.tnxTable_main {
  width: 100%;
  height: fit-content;
  border: 1px solid #ffffff;
  border-radius: 10px;
  box-shadow: -6px 10px 40px 0px #00000014;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.5) -1.68%,
    rgba(255, 255, 255, 0.1) 100%
  );
  padding: 2rem 2rem;
}
.sorttablebtn {
  border: 1px solid #234b9a;
  border-radius: 4px;
  color: #234b9a;
  cursor: pointer;
  
}

.sorttablebtnn {
  border-radius: 4px;
  color: #234b9a;
  cursor: pointer;
}

.sorttablebtn > button {
  width: 100%;
  height: 100%;
  padding: 8px 24px;
  outline: none;
  border: none;
  border-radius: inherit;
  background-color: transparent;
}

.sorttablebtnn > button {
  width: 100%;
  height: 100%;
  /* padding: 8px 24px; */
  outline: none;
  border: none;
  border-radius: inherit;
  background-color: transparent;
}

.sorttablebtnn img {
  width: 25px;
  height: 25px;
  margin-right: 1rem;
}

.tableFilterSection input {  
  border: 1px solid #234b9a;
  background: #eaf4fe;
  height: 40px;
  width: 41%;
  outline: none;
  border-radius: 4px;
  padding: 8.5px 12px;
  font-size: 12px;
  color: #000000;
}

.tableContainer {
  width: 100%;
  overflow-x: auto;
}
/* .tableContainer table {
  width: 1120px;
} */

.tnxHistoryheader {
  background: linear-gradient(90deg, #77a5ff 0%, #cfdfff 40.5%, #77a5ff 100%);
  border-radius: 0px 4px 4px 0px;
}

.tnxHistoryheader > tr {
  height: 56px;
}
.tnxHistoryheader > tr > th {
  color: #46474a;
  font-size: 16px;
  padding: 4px 8px;
  vertical-align: middle;
  font-weight: 700;
  background: transparent;
  font-family: "Quicksand";
}

.boder-Rght{
  border-right: 1px solid #0000001A;
}

.hdrbdrlft {
  padding: 4px 7px;
  font-size: 15px;
  display: block;
  width: 100%;
  text-align: left;
  border-right: 1px solid #759deb;
}

.tnxhtrbdytbl > tr {
  height: 56px;
  border-bottom: 1px solid #0000000d;
}
.tnxhtrbdytbl > tr > td {
  color: #000000;
  font-size: 16px;
  padding: 8px 16px;
  vertical-align: middle;
  font-weight: 500;
  vertical-align: middle;
  font-family: "Quicksand";
}



@media screen and (max-width: 1300px) {
  .tnxTable_main {
    padding: 0px;
  }
  .widthRespos {
    padding: 0px 10px;
  }
  .tableFilterSection {
    padding: 0px 10px;
  }
  .tnxTable_main > h1 {
    padding: 10px;
  }
}
@media screen and (max-width: 1461px) {
  .pynWltAdr > span:first-child{
    font-size: 12px;
  }
  .pynWltAdr > span:last-child{
    font-size: 12px;
  }
  .polygon_card{
    padding: 17px;
  }

  .copyaddicon>svg{
   font-size: 12px;
  }
}
@media screen and (max-width: 576px) {
  .sorttablebtn {
    /* width: 100%; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Migration/Index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;;AAEtB;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,2BAA2B;;EAE3B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA;;;;GAIG;;AAEH;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC;;;;GAIC;EACD,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;;AAEjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;;GAEG;;AAEH;EACE,2EAA2E;EAC3E,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;;;AAIA;EACE;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;;EAEA;GACC,eAAe;EAChB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".home_main {\n  width: 100%;\n  height: fit-content;\n}\n\n/* Balance Cards css */\n\n.balance_cards {\n  width: 100%;\n}\n\n.polygon_card {\n  width: 100%;\n  border: 1px solid #ffffff;\n  box-shadow: -6px 10px 40px 0px #00000014;\n  border-radius: 14px;\n  padding: 24px;\n  background-color: #ffffff90;\n\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: fit-content;\n}\n.polygon_card22 {\n  background-color: #ffffff;\n}\n\n/* .balance_cards{\n  background-image: url('../../assets/networkSecBackground.png');\n  background-repeat: no-repeat;\n  background-size: cover;\n} */\n\n.imgbox {\n  background-color: #1d70d2;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.bnbimgbox {\n  background-color: #f0b90b;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.imgbox img {\n  width: 24px;\n  height: 24px;\n}\n\n.card_header > span {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.pynWltAdr {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 2px;\n  flex-wrap: wrap;\n}\n\n.minimizeOpacity {\n  opacity: 0.5;\n}\n\n.pynWltAdr > span:first-child {\n  color: #000000;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n#my-tooltip-1,\n#my-tooltip-2 {\n  padding: 3px 5px;\n}\n\n.pynWltAdr > span:last-child {\n  color: #000000;\n  font-size: 14px;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n.copyaddicon {\n  cursor: pointer;\n}\n\n.maticBalance {\n  width: 100%;\n  background: #1d70d21a;\n  border-radius: 8px;\n  padding: 9px 10px;\n  color: #000000;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.nbnbgColor {\n  background: #f0b90b1a;\n}\n\n.maticBalance > span:first-child {\n  font-weight: 500;\n  margin-right: 10px;\n  font-size: 15px;\n}\n.maticBalance > span:last-child {\n  font-weight: 600;\n  font-size: 15px;\n}\n\n/* Transaction Table CSS */\n.tnxTable_main {\n  width: 100%;\n  height: fit-content;\n  border: 1px solid #ffffff;\n  border-radius: 10px;\n  box-shadow: -6px 10px 40px 0px #00000014;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.5) -1.68%,\n    rgba(255, 255, 255, 0.1) 100%\n  );\n  padding: 2rem 2rem;\n}\n.sorttablebtn {\n  border: 1px solid #234b9a;\n  border-radius: 4px;\n  color: #234b9a;\n  cursor: pointer;\n  \n}\n\n.sorttablebtnn {\n  border-radius: 4px;\n  color: #234b9a;\n  cursor: pointer;\n}\n\n.sorttablebtn > button {\n  width: 100%;\n  height: 100%;\n  padding: 8px 24px;\n  outline: none;\n  border: none;\n  border-radius: inherit;\n  background-color: transparent;\n}\n\n.sorttablebtnn > button {\n  width: 100%;\n  height: 100%;\n  /* padding: 8px 24px; */\n  outline: none;\n  border: none;\n  border-radius: inherit;\n  background-color: transparent;\n}\n\n.sorttablebtnn img {\n  width: 25px;\n  height: 25px;\n  margin-right: 1rem;\n}\n\n.tableFilterSection input {  \n  border: 1px solid #234b9a;\n  background: #eaf4fe;\n  height: 40px;\n  width: 41%;\n  outline: none;\n  border-radius: 4px;\n  padding: 8.5px 12px;\n  font-size: 12px;\n  color: #000000;\n}\n\n.tableContainer {\n  width: 100%;\n  overflow-x: auto;\n}\n/* .tableContainer table {\n  width: 1120px;\n} */\n\n.tnxHistoryheader {\n  background: linear-gradient(90deg, #77a5ff 0%, #cfdfff 40.5%, #77a5ff 100%);\n  border-radius: 0px 4px 4px 0px;\n}\n\n.tnxHistoryheader > tr {\n  height: 56px;\n}\n.tnxHistoryheader > tr > th {\n  color: #46474a;\n  font-size: 16px;\n  padding: 4px 8px;\n  vertical-align: middle;\n  font-weight: 700;\n  background: transparent;\n  font-family: \"Quicksand\";\n}\n\n.boder-Rght{\n  border-right: 1px solid #0000001A;\n}\n\n.hdrbdrlft {\n  padding: 4px 7px;\n  font-size: 15px;\n  display: block;\n  width: 100%;\n  text-align: left;\n  border-right: 1px solid #759deb;\n}\n\n.tnxhtrbdytbl > tr {\n  height: 56px;\n  border-bottom: 1px solid #0000000d;\n}\n.tnxhtrbdytbl > tr > td {\n  color: #000000;\n  font-size: 16px;\n  padding: 8px 16px;\n  vertical-align: middle;\n  font-weight: 500;\n  vertical-align: middle;\n  font-family: \"Quicksand\";\n}\n\n\n\n@media screen and (max-width: 1300px) {\n  .tnxTable_main {\n    padding: 0px;\n  }\n  .widthRespos {\n    padding: 0px 10px;\n  }\n  .tableFilterSection {\n    padding: 0px 10px;\n  }\n  .tnxTable_main > h1 {\n    padding: 10px;\n  }\n}\n@media screen and (max-width: 1461px) {\n  .pynWltAdr > span:first-child{\n    font-size: 12px;\n  }\n  .pynWltAdr > span:last-child{\n    font-size: 12px;\n  }\n  .polygon_card{\n    padding: 17px;\n  }\n\n  .copyaddicon>svg{\n   font-size: 12px;\n  }\n}\n@media screen and (max-width: 576px) {\n  .sorttablebtn {\n    /* width: 100%; */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
